import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NpfHome from './npf/Home';
import NpfProjects from './npf/OurProjects';
import ContactUs from './npf/ContactUs';
import OurBlog from './npf/OurBlog';
import { IntlProvider } from "react-intl";
import enMessages from "./locales/en.json";
import viMessages from './locales/vi.json'
import Header from './npf/Header';
import Footer from './npf/Footer';
import AboutUs from "./npf/AboutUs";
import News from './npf/News';
import 'antd/dist/reset.css';
import TopPanel from "./npf/TopPanel";
import Privacy from "./npf/Privacy";
import VideoPage from "./npf/VideoPage";
import ScrollToTop from "./helpers/ScrollToTop";
import InnerTransformation from './npf/InnerTransformation'
import ChangeMakers from "./npf/ChangeMakers";
import InspiringVietnam from "./npf/InspiringVietnam";
import ThrivingCommunities from "./npf/ThrivingCommunities";
import EducationForAll from "./npf/EducationForAll";
import NotFound from "./npf/NotFound";
import NewNews from "./npf/NewNews";

const localeMessages = {
  en: enMessages,
  vi: viMessages,
};

function App() {

  const [lang, setLang] = useState('en');

  const toggleLang = () => {
    lang === 'en' ? setLang('vi') : setLang('en');
  };

  return (
    <div className="App">
      <IntlProvider
        onError={(err) => {
          if (err.code === 'MISSING_TRANSLATION') {
            return;
          }
          console.error(err);
        }}
        locale={lang} messages={localeMessages[lang]}>
        <Router>
          <ScrollToTop />
          <TopPanel toggleLang={toggleLang} lang={lang} />
          <Header toggleLang={toggleLang} lang={lang}/>
          <Routes>
            <Route path='/' exact element={<NpfHome />}/>
            <Route path='/about' element={<AboutUs />}/>
            <Route path='/ourservice/innertransformation' element={<InnerTransformation />}/>
            <Route path='/ourservice/changemakers' element={<ChangeMakers />}/>
            <Route path='/ourservice/inspiring-vietnam' element={<InspiringVietnam />}/>
            <Route path='/ourservice/communities' element={<ThrivingCommunities />}/>
            <Route path='/ourservice/education' element={<EducationForAll />}/>
            <Route path='/news' element={<NewNews />}/>
            {/*<Route path='/livelihood' exact element={<NpfProjects />}/>*/}
            {/*<Route path='/inner-change' exact element={<NpfProjects />}/>*/}
            {/*<Route path='/systems-change' exact element={<NpfProjects />}/>*/}
            {/*<Route path='/news' exact element={<News />}/>*/}
            <Route path='/contact' exact element={<ContactUs />}/>
            <Route path='/blog' exact element={<OurBlog />}/>
            <Route path='/privacy-policy' exact element={<Privacy />}/>
            <Route path='/ripplesofkindness' exact element={<VideoPage />}/>
            <Route path='*' element={<NotFound />}/>
          </Routes>
          <Footer toggleLang={toggleLang} />
        </Router>
      </IntlProvider>
    </div>
  );
}

export default App;
